/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type EnumCambiamentoStatoRequestTransizione =
  (typeof EnumCambiamentoStatoRequestTransizione)[keyof typeof EnumCambiamentoStatoRequestTransizione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumCambiamentoStatoRequestTransizione = {
  PRONTO_ALLA_FIRMA: 'PRONTO_ALLA_FIRMA',
  COMPLETA: 'COMPLETA',
  RIPORTA_IN_COMPILAZIONE: 'RIPORTA_IN_COMPILAZIONE',
} as const;
